'use strict';

const { h } = require('phy');
const { useState, useEffect } = require('preact/hooks');
const Lock = require('@design-system/ui-icons/preact/Lock').default;
const {
  createStyles,
  HalfSheet,
  ModalCloseButton,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
} = require('@design-system/react');

const styles = createStyles(theme => ({
  guestCheckoutButton: {
    marginBottom: theme.spaces.spacing16,
  },
  buttons: {
    width: '100%',
  },
  body: {
    paddingTop: theme.spaces.spacing16,
  },
  footer: {
    paddingTop: theme.spaces.spacing8,
  },
}));

// Using this variable in closure to toggle the halfsheet
let open = true;

module.exports = ({ handleGuestClick, handleSigninClick }) => {
  const [isOpen, setIsOpen] = useState(open);
  const { I18n } = window;

  useEffect(() => {
    // This is will unmount callback
    return () => {
      open = true;
    };
  });

  const handleOnClose = () => {
    open = false;
    // using setIsOpen to just trigger rerender
    setIsOpen(!isOpen);
  };

  return h(
    HalfSheet,
    {
      className: 'guest-checkout',
      id: 'guest-checkout',
      isOpen: open,
      'data-bhw': 'GuestCheckoutHalfsheet',
      onClose: handleOnClose,
    },
    h(
      '#guest-checkout-half-sheet',
      h(ModalCloseButton, { 'data-bhw': 'GuestCheckoutHalfsheet_CloseButton' }),
      h(
        ModalHeader,
        { 'data-bhw': 'GuestCheckoutHalfsheet_Header' },
        I18n.t('js.modules.guest_checkout.half_sheet.title')
      ),
      h(
        ModalBody,
        {
          style: [styles.body],
        },
        // As of now passing className/class/id attribute in design component is not working.
        // Thus we have these wrapper to make integration test case happy.
        // We can rid of wrappers once we have that capability from design-system.
        h(
          '.gc-btn-continue-guest',
          h(
            Button,
            {
              onClick: handleGuestClick,
              style: [styles.guestCheckoutButton, styles.buttons],
              variant: 'cta',
              'data-bhw': 'GuestCheckoutHalfsheet_ContinueButton',
            },
            I18n.t('js.modules.guest_checkout.half_sheet.continue_as_guest')
          )
        ),
        h(
          '.gc-btn-signin',
          h(
            Button,
            {
              onClick: handleSigninClick,
              style: [styles.buttons],
              variant: 'secondary',
              'data-bhw': 'GuestCheckoutHalfsheet_SigninButton',
            },
            I18n.t('js.modules.guest_checkout.half_sheet.sign_in_sign_up')
          )
        )
      ),
      h(
        ModalFooter,
        {
          style: [
            styles.footer,
            { 'justify-content': 'left', 'align-items': 'end' },
          ],
          'data-bhw': 'GuestCheckoutHalfsheet_FooterInfo',
        },
        h(Lock, { height: '16px', width: '16px' }),
        h(
          '.info-text',
          {
            style: {
              'font-size': '12px',
              'line-height': '18px',
              'margin-left': '6px',
            },
          },
          I18n.t('js.modules.guest_checkout.half_sheet.info_text')
        )
      )
    )
  );
};
